import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { fetchPlaces } from '../api';
import PlaceCard from './PlaceCard';
import Pagination from './Pagination';

const PlaceList = () => {
    const [searchParams] = useSearchParams();
    const [places, setPlaces] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [pagination, setPagination] = useState({
        current_page: 1,
        total_pages: 1,
        total_items: 0,
        per_page: 12
    });

    useEffect(() => {
        loadPlaces();
    }, [searchParams]);

    const loadPlaces = async () => {
        try {
            setLoading(true);
            const page = parseInt(searchParams.get('page')) || 1;
            const region = searchParams.get('region');
            const type = searchParams.get('type');
            const query = searchParams.get('query');

            const response = await fetchPlaces({
                page,
                region,
                type,
                query
            });

            // Проверяем структуру ответа
            const placesData = Array.isArray(response) ? response : 
                             response.data ? response.data : [];
            
            const meta = response.meta || {
                current_page: 1,
                last_page: 1,
                total: 0,
                per_page: 12
            };

            setPlaces(placesData);
            setPagination({
                current_page: meta.current_page || 1,
                total_pages: meta.last_page || 1,
                total_items: meta.total || 0,
                per_page: meta.per_page || 12
            });
        } catch (err) {
            console.error('Error loading places:', err);
            setError('Ошибка при загрузке данных');
            setPlaces([]);
            setPagination({
                current_page: 1,
                total_pages: 1,
                total_items: 0,
                per_page: 12
            });
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = (page) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', page);
        window.history.pushState({}, '', `?${newParams.toString()}`);
        loadPlaces();
    };

    if (loading) {
        return (
            <div className="loading-container">
                <div className="loading">Загрузка...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="error-container">
                <div className="error">{error}</div>
            </div>
        );
    }

    return (
        <div className="container">
            <div className="places-header">
                <h2>Туристические места</h2>
                {pagination.total_items > 0 && (
                    <p className="places-count">
                        Найдено мест: {pagination.total_items}
                    </p>
                )}
            </div>

            <div className="grid">
                {places.map(place => (
                    <PlaceCard key={place.id} place={place} />
                ))}
            </div>

            {places.length === 0 && (
                <div className="no-results">
                    <p>По вашему запросу ничего не найдено</p>
                </div>
            )}

            {pagination.total_pages > 1 && (
                <Pagination
                    currentPage={pagination.current_page}
                    totalPages={pagination.total_pages}
                    onPageChange={handlePageChange}
                />
            )}
        </div>
    );
};

export default PlaceList;